<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box">
          <div class="panel-header">
            <div class="panel-title">신규 문의 현황</div>
          </div>
          <div class="panel-content">
            <period-picker style="margin-bottom:20px" @select="res => select('cs',res)"></period-picker>
            <div class="grid" :style="gridStyle(cs.length)">
              <div v-for="(item,idx) in cs" :key="`cs-${idx}`"
                   class="content-box" @click="routerPush(getPath(item.link))">
                <div class="content-box-title">{{ item.label }}</div>
                <div class="lp-count">{{ item.today_count|currencyNum }}</div>
                <div class="content-s-wrapper">신규 전체<span class="content-s primary">{{ item.new_count|currencyNum }}</span></div>
              </div>
            </div>
          </div>

        </div>
        <div class="box">
          <div class="panel-header">
            <div class="panel-title">신규 템플릿 소스 관련 현황</div>
          </div>
          <div class="panel-content">
            <period-picker style="margin-bottom:20px" @select="res => select('templates',res)"></period-picker>
            <div class="grid" :style="gridStyle(templates.length)">
              <div v-for="(item,idx) in templates" :key="`templates-${idx}`"
                   class="content-box" @click="routerPush(getPath(item.link))">
                <div class="content-box-title">{{ item.label }}</div>
                <div class="lp-count">{{ item.today_count|currencyNum }}</div>
                <div class="content-s-wrapper">신규 전체<span class="content-s primary">{{ item.new_count|currencyNum }}</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="panel-header">
            <div class="panel-title">회원 가입 현황</div>
          </div>
          <div class="panel-content">
            <period-picker style="margin-bottom:20px"  @select="res => select('users',res)"></period-picker>
            <div class="grid" :style="gridStyle(users.length)">
              <div v-for="(item,sIdx) in users" :key="`users-${sIdx}`"
                   class="content-box" @click="routerPush(getPath('user'))">
                <div class="content-box-title">{{ item.label }}</div>
                <div class="lp-count">{{ item.new|currencyNum }}</div>
                <div class="content-s-wrapper">전체<span class="content-s primary">{{ item.count|currencyNum }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="box">
          <div class="panel-header">
            <div class="panel-title">매출 현황</div>
          </div>
          <div class="panel-content">
            <period-picker @select="res => select('accounts',res)"></period-picker>
          </div>
          <div class="panel-content">
            <div class="content-box" @click="routerPush(getPath('launchpack/utilize/all'))">
              <div class="content-box-title">결제완료(입금완료) 금액</div>
              <div class="lp-count">{{ accounts|currency }}</div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="panel-header">
            <div class="panel-title">서비스 현황</div>
          </div>
          <div class="panel-content">
            <period-picker @select="res => select('service',res)"></period-picker>
          </div>

          <div class="panel-content">
            <div class="content-title">테마 (무료플랜)</div>
            <div class="grid" :style="gridStyle(trial.length)">
              <div v-for="(item,sIdx) in trial" :key="`trial-${sIdx}`"
                   class="content-box" @click="routerPush(getPath('launchpack/service'))">
                <div class="content-box-title">{{ item.label }}</div>
                <div class="lp-count">{{ item.new_count|currencyNum }}</div>
                <div class="content-s-wrapper">전체<span class="content-s primary">{{ item.count|currencyNum }}</span></div>
              </div>
            </div>
          </div>

          <div v-for="(s,idx) in service" :key="`service-${idx}`"
               class="panel-content">
            <div class="content-title">{{ s.title }}</div>
            <div class="grid" :style="gridStyle(s.list.length)">
              <div v-for="(item,sIdx) in s.list" :key="`service-${sIdx}`"
                   class="content-box" @click="routerPush(getPath('launchpack/service'))">
                <div class="content-box-title">{{ item.label }}</div>
                <div class="lp-count">{{ item.new_count|currencyNum }}</div>
                <div class="content-s-wrapper">전체<span class="content-s primary">{{ item.count|currencyNum }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PeriodPicker from "../../module/admin/PeriodPicker";
  export default {
    name: "SuperadminDashboard",
    components: {PeriodPicker},
    created() {
      this.getData();
    },
    data() {
      return {
        cs: [],
        templates: [],
        service: [],
        trial: [],
        users: [],
        accounts: 0
      }
    },
    methods: {
      select(key, res) {
        this.$axios.get(this.getUrl(`dashboard/${key}?${res}`)).then(res => {
          if(key === 'service') {
            this.trial = res.data.trial;
            this.service = res.data.service;
          } else if(key === 'accounts') {
           this.accounts = res.data.price;
          }
          else {
            this[key] = res.data;
          }
        });
      },
      getData() {
        this.$axios.get(this.getUrl('dashboard')).then(res => {
          this.cs = res.data.cs;
          this.templates = res.data.templates;
          this.service = res.data.service;
          this.trial = res.data.trial;
          this.users = res.data.users;
          this.accounts = res.data.accounts.price;
        });
      },
      gridStyle(n) {
        return `grid-template-columns:repeat(${n}, 1fr)`;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'

  .panel-title
    color $main
    font-size 21px
    font-weight 300

  .panel-content
    padding 20px

  .content-title
    font-size 15px
    margin-bottom 8px

  .box
    padding 0

  .panel-header
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px solid #eeeeee

  .content-box
    padding 16px 24px
    border 1px solid #eee
    border-left 0
    cursor pointer
    user-select none

  .content-box:first-child
    border-left 1px solid #eee
    border-top-left-radius 6px
    border-bottom-left-radius 6px

  .content-box:last-child
    border-top-right-radius 6px
    border-bottom-right-radius 6px

  .content-box:hover
    background-color #eee

  .content-box-title
    font-size 14px
    color #787878
    margin-bottom 8px

  .content-box-data
    font-size 18px
    font-weight 600

  .lp-count
    font-size 18px
    line-height 18px
    font-weight 600

  .content-s-wrapper
    margin-top 4px
    font-size 13px

  .content-s
    margin-left 4px
    font-weight 700

  .primary
    color $primary

  .chart-label
    display flex
    align-items center
    gap 0 4px
    font-size 13px
    color #4A4A4A

  .chart-count
    font-size 14px

  .grid
    display grid
</style>
